import React from "react";
import { ThemeProvider } from "@mui/material";
import { Route, Routes, useLocation } from "react-router-dom";

import { RoutePaths } from "src/app/model";
import { ModalWidgets } from "src/app/ui/ModalWidgets";
import { BackdropLoading } from "src/app/ui/BackdropLoading";
import { Dashboard } from "src/app/ui/Dashboard";
import { PrivacyPolicy, ToolsPage } from "src/pages";

import { theme } from "./model/theme";

export const App: React.FC = () => {
  const { pathname } = useLocation();
  return (
    <ThemeProvider theme={theme(pathname)}>
      <Routes>
        <Route path={RoutePaths.HOME} element={<Dashboard />} />
        <Route path={RoutePaths.ABOUT_US} element={<Dashboard />} />
        <Route path={RoutePaths.SERVICES} element={<Dashboard />} />
        <Route path={RoutePaths.PROJECTS} element={<Dashboard />} />
        <Route path={RoutePaths.TOOLS} element={<ToolsPage />} />
        <Route path={RoutePaths.PRIVACY_POLICY} element={<PrivacyPolicy />} />
        <Route path={RoutePaths.BLOGS} element={<Dashboard />} />
        <Route path={RoutePaths.CONTACTS} element={<Dashboard />} />
      </Routes>


      <ModalWidgets />
      <BackdropLoading />
    </ThemeProvider>
  );
};
